import classes from './TasksPanel.module.css';
import * as React from 'react';
import classNames from 'classnames';
import { useFilters, useGroupBy } from '../../state/context';
import OrganizationsTasks from './OrganizationsTasks';
import SolutionsTasks from './SolutionsTasks';
import Count from './Count';
import { HEADER_HEIGHT } from '../../layout';
import { onToggleTasksPanel } from '../../state/actions';
import Checkbox from '../Checkbox';

const TasksPanel = () => {
  const [isExpanded, setIsExpanded] = React.useState<boolean>(false);
  const [filters, setFilters] = useFilters();
  const [groupBy] = useGroupBy();
  const excludeOnHold = filters.includes('exclude-on-hold');

  React.useEffect(() => {
    return onToggleTasksPanel(setIsExpanded);
  }, []);

  return (
    <div
      className={classNames(
        classes['panel'],
        isExpanded && classes['expanded'],
      )}
    >
      <div
        className={classes['header']}
        style={{
          height: HEADER_HEIGHT,
        }}
      >
        Sager der endnu ikke er tildelt et sprint <Count />
        <button className={classes['tab']} onClick={() => setIsExpanded(!isExpanded)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="102"
            height="24"
            viewBox="0 0 102 24"
          >
            <path
              fill="#FFF"
              fillRule="evenodd"
              d="M102 8v16H0L8.861 4.667A8 8 0 0116.134 0H94a8 8 0 018 8z"
            />
          </svg>
          <span>Andre sager</span>
        </button>
        <div className="absolute left-8 bottom-7 capitalize text-sm font-medium flex items-center">
          <Checkbox
            checked={excludeOnHold === false}
            onChange={() => {
              if (excludeOnHold) {
                setFilters(filters.filter((filter) => filter !== 'exclude-on-hold'));
              } else {
                setFilters([...filters, 'exclude-on-hold']);
              }
            }}
          >
            <div className="hold-badge mr-2" /> Sager sat på hold
          </Checkbox>
        </div>
      </div>
      <div className={classes['content']}>
        {groupBy === 'organization' && (
          <OrganizationsTasks />
        )}
        {groupBy === 'solution' && (
          <SolutionsTasks />
        )}
      </div>
    </div>
  );
};

export default TasksPanel;
